import { Link, usePage } from "@inertiajs/react";
import { Button } from "@/components/ui/button";

export default function AdminLayout({ children }) {
  const { user } = usePage().props;

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link href="/admin" className="font-semibold text-lg hover:text-gray-600">
            Admin
          </Link>
          {user && (
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600">{user.name}</span>
              <Button variant="outline" size="sm" asChild>
                <Link href="/logout" method="delete">
                  Déconnexion
                </Link>
              </Button>
            </div>
          )}
        </div>
      </header>
      <div className="max-w-5xl mx-auto">{children}</div>
    </div>
  );
}
